import { render } from "./MainPart.vue?vue&type=template&id=5da25a88&scoped=true"
import script from "./MainPart.vue?vue&type=script&lang=js"
export * from "./MainPart.vue?vue&type=script&lang=js"

import "./MainPart.vue?vue&type=style&index=0&id=5da25a88&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da25a88"]])

export default __exports__